
import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from 'frame'
import { constants as fromEndOfLease } from 'features/report-end-of-lease'
import { constants as fromExtensionRentals } from 'features/report-extension-rentals'
import { constants as fromKmTracking } from 'features/report-km-tracking'
import { constants as fromUpcomingMaturities } from 'features/report-upcoming-maturities'
import { constants as fromVehicleServicing } from 'features/report-vehicle-servicing'
import { constants as fromVehiclesOnOrder } from 'features/report-vehicles-on-order'
import { constants as fromWofRego } from 'features/report-wof-rego'
import { constants as fromIncidentManagment } from 'features/report-incident-management'
import { constants as fromDocuments } from 'features/report-documents'

import { ModuleRoutes as UpcomingMaturitiesRoute } from 'features/report-upcoming-maturities'
import { ModuleRoutes as EndOfLeaseRoute } from 'features/report-end-of-lease'
import { ModuleRoutes as ExtensionRentalsRoute } from 'features/report-extension-rentals'
import { ModuleRoutes as KmTrackingRoute } from 'features/report-km-tracking'
import { ModuleRoutes as VehicleServicingRoute } from 'features/report-vehicle-servicing'
import { ModuleRoutes as VehiclesOnOrderRoute } from 'features/report-vehicles-on-order'
import { ModuleRoutes as WofRegoRoute } from 'features/report-wof-rego'
import { ModuleRoutes as IncidentManagmentRoute } from 'features/report-incident-management'
import { ModuleRoutes as DocumentsRoute } from 'features/report-documents' // "/reports/maturities" → "maturities"
import { constants as fromVehicleEmissions, ModuleRoutes as VehicleEmissionsRoute } from 'features/report-vehicle-emissions'
import { constants as fromFuelExceptions, ModuleRoutes as FuelExceptionsRoute } from 'features/report-exceptions'
import { constants as fromMissingOdometers, ModuleRoutes as MissingOdometersRoute } from 'features/report-missing-odometers'


const strip = p => p.split('/').pop()
const ReportsRoute = () => (
  <Layout>
    <Routes>
      <Route path={strip(fromUpcomingMaturities.PATH_ALL)} element={<UpcomingMaturitiesRoute />} />
      <Route path={strip(fromEndOfLease.PATH_ALL)} element={<EndOfLeaseRoute />} />
      <Route path={strip(fromExtensionRentals.PATH_ALL)} element={<ExtensionRentalsRoute />} />
      <Route path={strip(fromKmTracking.PATH_ALL) + '/*'} element={<KmTrackingRoute />} />
      <Route path={strip(fromVehicleServicing.PATH_ALL) + '/*'} element={<VehicleServicingRoute />} />
      <Route path={strip(fromVehiclesOnOrder.PATH_ALL)} element={<VehiclesOnOrderRoute />} />
      <Route path={strip(fromWofRego.PATH_ALL)} element={<WofRegoRoute />} />
      <Route path={strip(fromIncidentManagment.PATH_ALL) + '/*'} element={<IncidentManagmentRoute />} />
      <Route path={strip(fromDocuments.PATH_ALL) + '/*'} element={<DocumentsRoute />} />
      <Route path={strip(fromVehicleEmissions.PATH_ALL)} element={<VehicleEmissionsRoute />} />
      <Route path={strip(fromMissingOdometers.PATH_ALL)} element={<MissingOdometersRoute />} />
      <Route path={strip(fromFuelExceptions.PATH_ALL)} element={<FuelExceptionsRoute />} />

      {/* /reports → /reports/maturities */}
      <Route index element={<Navigate to={strip(fromUpcomingMaturities.PATH_ALL)} replace />} />
    </Routes>
  </Layout>
)

export default ReportsRoute
